export const B2_ACTIVITIES = {
  block1: {
    title: 'Analyse & Réflexion',
    subtitle: 'Débats contemporains, dilemmes éthiques, pensée critique',
    parts: [
      {
        title: 'Monde du travail & économie',
        activities: [
          {
            id: 'semaine-4-jours',
            num: 1,
            title: 'La semaine de 4 jours',
            prompt: 'La semaine de 4 jours est-elle viable pour toutes les entreprises ? Argumente.',
            modele: 'La semaine de 4 jours peut améliorer la productivité et le bien-être des salariés. Toutefois, elle n\'est pas adaptée à tous les secteurs, notamment les services continus comme la santé. Il faudrait l\'adapter au cas par cas.',
            structures: ['Nuance (toutefois)', 'Nécessité (il faudrait)', 'Adaptation (au cas par cas)'],
          },
          {
            id: 'revenu-universel',
            num: 2,
            title: 'Le revenu universel',
            prompt: 'Un revenu de base pour tous : utopie ou solution réaliste ?',
            modele: 'Le revenu universel garantirait une sécurité minimale à chacun. Néanmoins, son financement pose un défi considérable. Par ailleurs, certains craignent qu\'il réduise la motivation au travail, bien que des expériences pilotes suggèrent le contraire.',
            structures: ['Conditionnel (garantirait)', 'Concession (néanmoins)', 'Opposition (bien que + subjonctif)'],
          },
          {
            id: 'obsolescence-metiers',
            num: 3,
            title: "L'obsolescence des métiers",
            prompt: "L'intelligence artificielle va-t-elle supprimer plus d'emplois qu'elle n'en crée ?",
            modele: 'L\'IA transforme le marché du travail en automatisant certaines tâches répétitives. Cependant, elle crée aussi de nouveaux métiers qui n\'existaient pas auparavant. L\'enjeu réside dans la formation continue pour accompagner cette transition.',
            structures: ['Gérondif (en automatisant)', 'Concession (cependant)', 'Localisation abstraite (l\'enjeu réside dans)'],
          },
          {
            id: 'entrepreneuriat-salariat',
            num: 4,
            title: 'Entrepreneuriat vs salariat',
            prompt: 'Vaut-il mieux créer son entreprise ou être salarié ? Compare les deux modèles.',
            modele: 'L\'entrepreneuriat offre une liberté incomparable, mais s\'accompagne d\'une grande incertitude financière. À l\'inverse, le salariat garantit une stabilité, au prix parfois d\'une certaine routine. Le choix dépend avant tout du tempérament de chacun.',
            structures: ['Opposition (à l\'inverse)', 'Concession (au prix de)', 'Relativisation (dépend de)'],
          },
          {
            id: 'deconnexion-numerique',
            num: 5,
            title: 'Le droit à la déconnexion',
            prompt: 'Les employés devraient-ils avoir un droit strict à la déconnexion en dehors des heures de travail ?',
            modele: 'Le droit à la déconnexion est essentiel pour préserver la santé mentale des travailleurs. En effet, la frontière entre vie professionnelle et personnelle s\'est considérablement estompée. Il conviendrait d\'instaurer des règles claires tout en gardant une certaine flexibilité.',
            structures: ['Jugement (essentiel)', 'Constat (en effet)', 'Impersonnel + conditionnel (il conviendrait de)'],
          },
          {
            id: 'economie-circulaire',
            num: 6,
            title: "L'économie circulaire",
            prompt: 'Peut-on concilier croissance économique et respect de l\'environnement ?',
            modele: 'L\'économie circulaire propose un modèle où les déchets deviennent des ressources. Bien que séduisant sur le papier, ce modèle nécessite des investissements massifs et un changement radical des habitudes de consommation. C\'est un défi collectif autant qu\'individuel.',
            structures: ['Subordonnée (où)', 'Bien que + subjonctif', 'Parallélisme (autant que)'],
          },
          {
            id: 'delocalisation',
            num: 7,
            title: 'La délocalisation',
            prompt: 'Les entreprises qui délocalisent ont-elles une responsabilité envers les employés locaux ?',
            modele: 'La délocalisation répond à une logique économique compréhensible. Pour autant, elle ne devrait pas se faire au détriment des travailleurs locaux. Les entreprises devraient assurer une transition accompagnée, incluant formation et reclassement.',
            structures: ['Concession (pour autant)', 'Obligation morale (ne devrait pas)', 'Participe présent (incluant)'],
          },
          {
            id: 'travail-passion',
            num: 8,
            title: 'Vivre de sa passion',
            prompt: '"Fais ce que tu aimes et tu ne travailleras jamais." Cette citation est-elle réaliste ?',
            modele: 'Cette citation est séduisante mais réductrice. Transformer une passion en métier implique des contraintes qui peuvent en altérer le plaisir. De surcroît, tout le monde n\'a pas les moyens financiers de poursuivre ses rêves sans filet de sécurité.',
            structures: ['Jugement nuancé (séduisante mais réductrice)', 'Conséquence (implique)', 'Addition (de surcroît)'],
          },
          {
            id: 'inegalites-salariales',
            num: 9,
            title: 'Les inégalités salariales',
            prompt: 'Comment expliquer et réduire les écarts de salaires dans une même entreprise ?',
            modele: 'Les inégalités salariales s\'expliquent par des facteurs historiques, structurels et parfois discriminatoires. Pour les réduire, il faudrait instaurer davantage de transparence sur les rémunérations et renforcer les audits internes. La volonté politique est déterminante.',
            structures: ['Énumération (historiques, structurels, discriminatoires)', 'Conditionnel (il faudrait)', 'Jugement (déterminante)'],
          },
          {
            id: 'management-horizontal',
            num: 10,
            title: 'Le management horizontal',
            prompt: 'Une entreprise peut-elle fonctionner efficacement sans hiérarchie ?',
            modele: 'Le management horizontal favorise l\'autonomie et la créativité des équipes. Toutefois, en l\'absence de structure claire, les prises de décision peuvent s\'avérer lentes et conflictuelles. Un équilibre entre horizontalité et cadrage semble être la clé.',
            structures: ['Conséquence (favorise)', 'Concession (toutefois)', 'Modération (semble être)'],
          },
        ],
      },
      {
        title: 'Technologie, science & éthique',
        activities: [
          {
            id: 'transhumanisme',
            num: 11,
            title: 'Le transhumanisme',
            prompt: 'Augmenter les capacités humaines par la technologie : progrès ou dérive ?',
            modele: 'Le transhumanisme promet de repousser les limites biologiques humaines. Or, il soulève des questions éthiques majeures : qui y aura accès ? Ne risque-t-on pas de créer une humanité à deux vitesses ? La prudence s\'impose face à ces avancées.',
            structures: ['Opposition (or)', 'Questions rhétoriques', 'Impersonnel (la prudence s\'impose)'],
          },
          {
            id: 'donnees-personnelles',
            num: 12,
            title: 'La vie privée numérique',
            prompt: 'Acceptons-nous trop facilement de céder nos données personnelles ?',
            modele: 'Nous cédons nos données souvent sans en mesurer les conséquences, par facilité ou ignorance. Pourtant, ces informations constituent un pouvoir considérable pour les entreprises qui les exploitent. Il est urgent de renforcer l\'éducation numérique dès le plus jeune âge.',
            structures: ['Cause (par facilité)', 'Opposition (pourtant)', 'Urgence (il est urgent de)'],
          },
          {
            id: 'clonage-ethique',
            num: 13,
            title: 'Le clonage',
            prompt: 'Le clonage thérapeutique est-il moralement acceptable ?',
            modele: 'Le clonage thérapeutique offre des perspectives médicales prometteuses, notamment pour la régénération de tissus. Cependant, il pose un dilemme éthique fondamental sur le statut de l\'embryon. La réponse varie selon les convictions philosophiques et religieuses de chacun.',
            structures: ['Notamment', 'Dilemme (cependant... fondamental)', 'Relativisation (varie selon)'],
          },
          {
            id: 'addiction-ecrans',
            num: 14,
            title: "L'addiction aux écrans",
            prompt: 'Les enfants devraient-ils être privés d\'écrans jusqu\'à un certain âge ?',
            modele: 'L\'exposition précoce aux écrans peut nuire au développement cognitif et social des enfants. Pour autant, une interdiction totale semble irréaliste dans notre société connectée. L\'encadrement parental et des limites raisonnables constituent un compromis plus viable.',
            structures: ['Potentiel négatif (peut nuire)', 'Concession (pour autant)', 'Solution nuancée (compromis)'],
          },
          {
            id: 'conquete-spatiale',
            num: 15,
            title: 'La conquête spatiale',
            prompt: 'Investir dans l\'exploration spatiale est-il justifié quand la Terre a tant de problèmes ?',
            modele: 'L\'exploration spatiale stimule l\'innovation technologique et pourrait assurer la survie de l\'humanité à long terme. Néanmoins, il est légitime de questionner ces investissements colossaux face aux urgences terrestres. L\'idéal serait de mener les deux fronts de manière simultanée.',
            structures: ['Conditionnel (pourrait)', 'Légitimité (il est légitime de)', 'Idéal (l\'idéal serait de)'],
          },
          {
            id: 'voitures-autonomes',
            num: 16,
            title: 'Les voitures autonomes',
            prompt: 'En cas d\'accident inévitable, qui la voiture autonome doit-elle protéger : ses passagers ou les piétons ?',
            modele: 'Ce dilemme, inspiré du problème du tramway, met en lumière les limites de la programmation éthique. Aucune réponse universelle n\'existe, car elle dépend de valeurs culturelles profondes. La transparence des algorithmes utilisés devrait être obligatoire.',
            structures: ['Référence (inspiré de)', 'Négation (aucune... n\'existe)', 'Obligation (devrait être)'],
          },
          {
            id: 'manipulation-genetique',
            num: 17,
            title: 'Les bébés génétiquement modifiés',
            prompt: 'Devrait-on pouvoir modifier le génome des enfants à naître pour éliminer des maladies ?',
            modele: 'Éliminer des maladies génétiques graves est un objectif louable. Toutefois, la frontière entre thérapie et amélioration est floue : où s\'arrête-t-on ? Le risque d\'eugénisme exige un cadre juridique international strict.',
            structures: ['Jugement (louable)', 'Question rhétorique (où s\'arrête-t-on ?)', 'Exigence (exige)'],
          },
          {
            id: 'deepfakes',
            num: 18,
            title: 'Les deepfakes',
            prompt: 'Comment lutter contre la désinformation générée par l\'IA sans restreindre la liberté d\'expression ?',
            modele: 'Les deepfakes représentent une menace sans précédent pour la vérité. Il faudrait investir dans des outils de détection performants tout en éduquant le public à l\'esprit critique. Censurer systématiquement n\'est pas la solution, car cela ouvrirait la porte à d\'autres abus.',
            structures: ['Sans précédent', 'Tout en + gérondif', 'Cause négative (car cela ouvrirait)'],
          },
          {
            id: 'neurosciences-marketing',
            num: 19,
            title: 'Le neuromarketing',
            prompt: 'Les entreprises qui utilisent les neurosciences pour influencer nos achats agissent-elles de manière éthique ?',
            modele: 'Le neuromarketing exploite nos biais cognitifs pour orienter nos décisions de consommation. Si l\'on peut considérer cela comme une forme de manipulation, d\'autres argueront qu\'il ne fait que rendre la publicité plus efficace. La question est celle du consentement éclairé.',
            structures: ['Exploitation (exploite)', 'Si l\'on peut...', 'Argumentation indirecte (d\'autres argueront)'],
          },
          {
            id: 'immortalite-numerique',
            num: 20,
            title: "L'immortalité numérique",
            prompt: 'Que penses-tu des entreprises qui proposent de créer un avatar IA d\'une personne décédée ?',
            modele: 'Cette technologie peut aider certaines personnes dans leur processus de deuil. En revanche, elle soulève des questions troublantes sur le consentement du défunt et le rapport naturel à la mort. Il y a un risque de ne jamais pouvoir tourner la page.',
            structures: ['Potentiel (peut aider)', 'Opposition (en revanche)', 'Risque (il y a un risque de)'],
          },
        ],
      },
      {
        title: 'Société, philosophie & identité',
        activities: [
          {
            id: 'cancel-culture',
            num: 21,
            title: 'La cancel culture',
            prompt: 'La "cancel culture" est-elle un outil de justice sociale ou une forme de censure collective ?',
            modele: 'La cancel culture permet de donner une voix aux victimes et de responsabiliser les personnes publiques. Cependant, elle peut aussi mener à des lynchages numériques disproportionnés, sans droit de réponse ni possibilité de rédemption. Un juste milieu reste à trouver.',
            structures: ['Permet de', 'Concession (cependant)', 'Sans + nom (sans droit de)'],
          },
          {
            id: 'merite-privilege',
            num: 22,
            title: 'Mérite ou privilège ?',
            prompt: 'La réussite est-elle vraiment le fruit du mérite individuel ?',
            modele: 'La méritocratie est un idéal séduisant, mais la réalité montre que le milieu social, le réseau et les opportunités jouent un rôle déterminant. Reconnaître ces inégalités de départ ne revient pas à nier l\'effort individuel, mais à contextualiser la réussite.',
            structures: ['Opposition (mais)', 'Négation nuancée (ne revient pas à... mais à)', 'Infinitif substantivé'],
          },
          {
            id: 'solitude-choisie',
            num: 23,
            title: 'La solitude choisie',
            prompt: 'Vivre seul(e) par choix est-il un acte de liberté ou un signe de repli sur soi ?',
            modele: 'La solitude choisie peut être un espace de ressourcement et de créativité. Elle ne doit pas être confondue avec l\'isolement subi. Chaque individu a des besoins sociaux différents, et vivre seul n\'est pas synonyme de souffrance.',
            structures: ['Peut être', 'Ne doit pas être confondu avec', 'Négation (n\'est pas synonyme de)'],
          },
          {
            id: 'langue-identite',
            num: 24,
            title: 'Langue et identité',
            prompt: 'Parler une autre langue change-t-il notre personnalité ?',
            modele: 'De nombreux bilingues rapportent se sentir différents selon la langue qu\'ils utilisent. Cela suggère que la langue façonne en partie notre perception du monde et nos interactions sociales. Toutefois, notre identité profonde reste probablement indépendante du code linguistique.',
            structures: ['Rapport indirect (rapportent)', 'Suggestion (cela suggère que)', 'Probabilité (probablement)'],
          },
          {
            id: 'bonheur-obligation',
            num: 25,
            title: "L'injonction au bonheur",
            prompt: 'La société nous impose-t-elle d\'être heureux en permanence ?',
            modele: 'La « tyrannie du bonheur » pousse les individus à masquer leurs difficultés derrière un optimisme de façade. Or, accepter les émotions négatives fait partie intégrante de la santé mentale. Il serait plus sain de normaliser la vulnérabilité.',
            structures: ['Métaphore (tyrannie du bonheur)', 'Opposition (or)', 'Conditionnel (il serait plus sain de)'],
          },
          {
            id: 'appropriation-culturelle',
            num: 26,
            title: "L'appropriation culturelle",
            prompt: 'Où se situe la frontière entre inspiration et appropriation culturelle ?',
            modele: 'L\'inspiration culturelle enrichit la création artistique, à condition qu\'elle s\'accompagne de respect et de reconnaissance. Le problème survient lorsqu\'une culture dominante exploite commercialement des éléments d\'une culture minoritaire sans en comprendre la signification.',
            structures: ['Condition (à condition que + subjonctif)', 'Temporelle (lorsque)', 'Sans + infinitif'],
          },
          {
            id: 'memoire-oubli',
            num: 27,
            title: 'Le droit à l\'oubli',
            prompt: 'Internet devrait-il permettre un « droit à l\'oubli » total ?',
            modele: 'Le droit à l\'oubli protège la vie privée et permet de tourner la page après des erreurs passées. Cependant, il entre en conflit avec le droit à l\'information et la mémoire collective. Un arbitrage au cas par cas semble préférable à une règle absolue.',
            structures: ['Permet de', 'Conflit (entre en conflit avec)', 'Préférence (semble préférable)'],
          },
          {
            id: 'education-competitivite',
            num: 28,
            title: "L'éducation compétitive",
            prompt: 'L\'esprit de compétition à l\'école est-il bénéfique ou néfaste pour les élèves ?',
            modele: 'La compétition peut stimuler certains élèves et les pousser à se dépasser. En revanche, elle génère aussi de l\'anxiété et favorise une vision utilitariste de l\'apprentissage. L\'idéal serait de combiner émulation saine et coopération.',
            structures: ['Potentiel (peut stimuler)', 'Opposition (en revanche)', 'Idéal (l\'idéal serait de)'],
          },
          {
            id: 'minimalisme',
            num: 29,
            title: 'Le minimalisme',
            prompt: 'Le minimalisme est-il un mode de vie accessible à tous ou un privilège ?',
            modele: 'Le minimalisme propose de se libérer de la surconsommation. Or, posséder peu est un luxe qui suppose d\'abord d\'avoir les moyens de choisir. Pour ceux qui manquent du nécessaire, le minimalisme relève davantage de la contrainte que du choix.',
            structures: ['Propose de', 'Opposition (or)', 'Distinction (davantage de... que du)'],
          },
          {
            id: 'normalite',
            num: 30,
            title: 'La norme et la différence',
            prompt: 'Qui définit ce qui est « normal » dans une société ?',
            modele: 'La normalité est une construction sociale qui évolue avec le temps et les cultures. Ce qui est considéré comme déviant aujourd\'hui peut devenir la norme demain. Plutôt que de chercher à se conformer, il vaudrait mieux cultiver la tolérance envers la diversité.',
            structures: ['Construction sociale', 'Potentiel futur (peut devenir)', 'Plutôt que de + infinitif'],
          },
        ],
      },
    ],
  },
  block2: {
    title: 'Réactions & Communication',
    subtitle: 'Situations professionnelles, médiation, persuasion avancée',
    parts: [
      {
        title: 'Réactions & Communication avancées',
        activities: [
          {
            id: 'negociation-salariale',
            num: 31,
            title: 'Négociation salariale',
            prompt: 'Tu estimes mériter une augmentation. Comment formules-tu ta demande de manière convaincante ?',
            modele: 'J\'aimerais aborder la question de ma rémunération. Depuis mon arrivée, j\'ai contribué à plusieurs projets clés et mes responsabilités ont considérablement évolué. Je souhaiterais que nous envisagions une revalorisation en cohérence avec mon engagement.',
            structures: ['Conditionnel poli (j\'aimerais, je souhaiterais)', 'Argumentation factuelle', 'Formule professionnelle'],
          },
          {
            id: 'mediation-conflit',
            num: 32,
            title: 'Médiateur dans un conflit',
            prompt: 'Deux collègues sont en conflit ouvert. Comment interviens-tu en tant que médiateur ?',
            modele: 'Je comprends que la situation soit tendue pour vous deux. Si vous le permettez, j\'aimerais entendre chaque point de vue séparément avant de chercher ensemble une solution. L\'objectif n\'est pas de désigner un coupable, mais de rétablir un dialogue constructif.',
            structures: ['Subjonctif (que la situation soit)', 'Conditionnel (j\'aimerais)', 'Négation... mais (n\'est pas... mais)'],
          },
          {
            id: 'feedback-negatif',
            num: 33,
            title: 'Donner un feedback négatif',
            prompt: 'Tu dois dire à un collègue que son travail n\'est pas satisfaisant. Comment le formules-tu ?',
            modele: 'J\'apprécie ton implication sur ce projet. Cependant, certains aspects méritent d\'être retravaillés pour atteindre le niveau attendu. Je te propose qu\'on identifie ensemble les points à améliorer et qu\'on définisse un plan d\'action.',
            structures: ['Sandwich positif-négatif-positif', 'Impersonnel (méritent d\'être)', 'Proposition (je te propose que + subjonctif)'],
          },
          {
            id: 'refuser-hierarchie',
            num: 34,
            title: 'Refuser une demande de sa hiérarchie',
            prompt: 'Ton supérieur te demande quelque chose que tu juges contraire à l\'éthique. Comment refuses-tu ?',
            modele: 'Je comprends l\'enjeu de cette demande. Toutefois, je ne me sens pas en mesure de l\'exécuter car elle va à l\'encontre de mes valeurs professionnelles. Je serais néanmoins disposé(e) à proposer une alternative qui respecte les objectifs tout en restant dans un cadre éthique.',
            structures: ['Compréhension + refus (je comprends... toutefois)', 'Valeurs (à l\'encontre de)', 'Alternative (néanmoins disposé à)'],
          },
          {
            id: 'presentation-imprevue',
            num: 35,
            title: 'Présentation imprévue',
            prompt: 'On te demande de prendre la parole devant un groupe sans préparation. Comment structures-tu ton intervention ?',
            modele: 'Merci de me donner la parole. Je vais structurer mes remarques autour de trois points essentiels. Premièrement... Deuxièmement... Enfin... En résumé, je dirais que l\'essentiel est de rester pragmatique et de garder nos objectifs en tête.',
            structures: ['Remerciement', 'Structuration (premièrement, deuxièmement, enfin)', 'Synthèse (en résumé)'],
          },
          {
            id: 'client-mecontent',
            num: 36,
            title: 'Client mécontent',
            prompt: 'Un client est furieux et exprime sa frustration de manière agressive. Comment désamorces-tu la situation ?',
            modele: 'Je comprends parfaitement votre frustration et je vous prie d\'accepter nos excuses. Permettez-moi de prendre en charge votre dossier personnellement. Je m\'engage à vous proposer une solution concrète dans les 24 heures.',
            structures: ['Empathie (je comprends)', 'Formule d\'excuse', 'Engagement (je m\'engage à)'],
          },
          {
            id: 'rumeur-professionnelle',
            num: 37,
            title: 'Rumeur professionnelle',
            prompt: 'Une rumeur fausse circule à ton sujet au bureau. Comment réagis-tu ?',
            modele: 'Plutôt que d\'alimenter la rumeur en réagissant émotionnellement, je préfère clarifier la situation directement avec les personnes concernées. La transparence et le calme sont les meilleures armes contre la désinformation.',
            structures: ['Plutôt que de + infinitif', 'Préférence (je préfère)', 'Métaphore (armes contre)'],
          },
          {
            id: 'pitch-projet',
            num: 38,
            title: 'Pitcher un projet innovant',
            prompt: 'Tu as 2 minutes pour convaincre un investisseur de financer ton projet. Que dis-tu ?',
            modele: 'Notre solution répond à un besoin concret que rencontrent 80% des PME françaises. Nous avons déjà validé notre concept auprès de 50 clients pilotes avec un taux de satisfaction de 92%. Nous recherchons un partenaire stratégique pour passer à l\'échelle.',
            structures: ['Données chiffrées', 'Validation (nous avons validé)', 'Objectif (pour + infinitif)'],
          },
          {
            id: 'annonce-difficile',
            num: 39,
            title: 'Annoncer une mauvaise nouvelle',
            prompt: 'Tu dois annoncer à ton équipe que le projet est annulé. Comment le fais-tu ?',
            modele: 'J\'ai une annonce difficile à vous faire. Malgré nos efforts considérables, la direction a décidé d\'arrêter le projet pour des raisons budgétaires. Je tiens à souligner que la qualité de votre travail n\'est absolument pas en cause. Nous allons réorienter vos compétences vers de nouveaux projets.',
            structures: ['Annonce (j\'ai... à vous faire)', 'Concession (malgré)', 'Réassurance (je tiens à souligner)'],
          },
          {
            id: 'debat-public',
            num: 40,
            title: 'Intervenir dans un débat public',
            prompt: 'Lors d\'un débat, quelqu\'un déforme tes propos. Comment rectifies-tu ?',
            modele: 'Permettez-moi de préciser, car je crains que mes propos aient été mal interprétés. Ce que j\'ai voulu dire, c\'est que... Il ne s\'agit en aucun cas de... Je vous invite à distinguer entre ma position réelle et l\'interprétation qui en a été faite.',
            structures: ['Formule de rectification (permettez-moi de)', 'Crainte (je crains que + subjonctif)', 'Distinction (il ne s\'agit pas de)'],
          },
          {
            id: 'demission-elegante',
            num: 41,
            title: 'Démissionner avec élégance',
            prompt: 'Tu quittes ton entreprise. Comment formules-tu ta démission de manière professionnelle ?',
            modele: 'Après mûre réflexion, j\'ai pris la décision de poursuivre ma carrière ailleurs. Cette expérience a été extrêmement enrichissante et je vous suis reconnaissant(e) pour la confiance accordée. Je m\'engage à assurer une transition fluide durant mon préavis.',
            structures: ['Temporalité (après mûre réflexion)', 'Gratitude', 'Engagement professionnel'],
          },
          {
            id: 'interculturel',
            num: 42,
            title: 'Malentendu interculturel',
            prompt: 'Un collègue étranger se sent offensé par quelque chose que tu considères banal. Comment gères-tu ?',
            modele: 'Je suis sincèrement désolé(e) si mon comportement t\'a blessé(e). Ce n\'était absolument pas intentionnel. J\'aimerais comprendre ce qui t\'a gêné afin d\'éviter de reproduire cette situation à l\'avenir. Nos différences culturelles sont une richesse, pas un obstacle.',
            structures: ['Excuse sincère', 'Conditionnel (j\'aimerais)', 'Finalité (afin de)'],
          },
          {
            id: 'leadership-crise',
            num: 43,
            title: 'Leadership en situation de crise',
            prompt: 'Ton équipe est démoralisée après un échec. Comment les remotives-tu ?',
            modele: 'Je sais que ce résultat est décevant, et c\'est normal de se sentir frustré. Cependant, chaque échec contient des enseignements précieux. Analysons ensemble ce qui n\'a pas fonctionné, tirons-en des leçons, et repartons avec une stratégie renforcée.',
            structures: ['Empathie (je sais, c\'est normal)', 'Impératif inclusif (analysons, tirons, repartons)', 'Métaphore positive'],
          },
          {
            id: 'dire-non-diplomatiquement',
            num: 44,
            title: 'Dire non à un client important',
            prompt: 'Un client VIP fait une demande impossible à satisfaire. Comment refuses-tu sans le perdre ?',
            modele: 'Je mesure l\'importance de votre demande et je vous remercie de votre confiance. Malheureusement, nous ne sommes pas en mesure d\'y répondre dans ces conditions. En revanche, je peux vous proposer une alternative qui, je pense, répondra à vos besoins de manière tout aussi efficace.',
            structures: ['Reconnaissance (je mesure)', 'Refus atténué (nous ne sommes pas en mesure)', 'Alternative constructive'],
          },
          {
            id: 'mail-diplomatique',
            num: 45,
            title: 'Rédiger un mail diplomatique',
            prompt: 'Tu dois relancer un partenaire qui ne répond plus depuis 3 semaines. Que lui écris-tu ?',
            modele: 'J\'espère que vous allez bien. Je me permets de vous relancer concernant notre échange du [date]. Je comprends que vous ayez un emploi du temps chargé. Néanmoins, pourriez-vous m\'indiquer si vous êtes toujours intéressé(e) par notre collaboration ?',
            structures: ['Politesse (je me permets)', 'Compréhension (je comprends que + subjonctif)', 'Question indirecte (pourriez-vous)'],
          },
          {
            id: 'gerer-interruption',
            num: 46,
            title: 'Gérer une interruption répétée',
            prompt: 'Pendant une réunion, quelqu\'un t\'interrompt systématiquement. Comment réagis-tu fermement mais poliment ?',
            modele: 'J\'apprécie ta contribution, mais j\'aimerais pouvoir terminer mon point avant que nous en discutions. Cela permettra d\'avoir une vision complète de ma proposition. Je te donnerai volontiers la parole ensuite.',
            structures: ['Appréciation + mais', 'Conditionnel (j\'aimerais)', 'Futur d\'engagement (je te donnerai)'],
          },
          {
            id: 'convaincre-sceptique',
            num: 47,
            title: 'Convaincre un sceptique',
            prompt: 'Comment convaincs-tu quelqu\'un qui est fermement opposé à ton idée ?',
            modele: 'Je comprends tes réticences, et elles sont légitimes. Cependant, permets-moi de te présenter des éléments que tu n\'as peut-être pas encore considérés. Si après cela tu restes du même avis, je respecterai ta position.',
            structures: ['Validation (légitimes)', 'Hypothèse (peut-être pas encore)', 'Condition (si... je respecterai)'],
          },
          {
            id: 'excuse-professionnelle',
            num: 48,
            title: "S'excuser professionnellement",
            prompt: 'Tu as fait une erreur qui a eu des conséquences pour ton équipe. Comment t\'excuses-tu ?',
            modele: 'Je tiens à reconnaître mon erreur sans chercher d\'excuse. J\'aurais dû vérifier ces données plus attentivement. Je comprends l\'impact que cela a eu sur notre planning. Voici les mesures correctives que je propose pour que cela ne se reproduise pas.',
            structures: ['Responsabilité (je tiens à reconnaître)', 'Conditionnel passé (j\'aurais dû)', 'Action corrective'],
          },
          {
            id: 'reseau-professionnel',
            num: 49,
            title: 'Réseautage professionnel',
            prompt: 'Tu rencontres une personne influente dans ton domaine lors d\'un événement. Comment engages-tu la conversation ?',
            modele: 'Bonjour, j\'ai beaucoup apprécié votre intervention sur [sujet]. Votre approche de [thème] résonne particulièrement avec mes travaux actuels. J\'aimerais beaucoup avoir l\'occasion d\'en discuter plus en détail. Seriez-vous disponible pour un café prochainement ?',
            structures: ['Compliment sincère', 'Lien personnel (résonne avec)', 'Invitation ouverte (seriez-vous)'],
          },
          {
            id: 'transmission-savoir',
            num: 50,
            title: 'Transmettre un savoir',
            prompt: 'Comment expliques-tu un concept complexe à quelqu\'un qui n\'y connaît rien ?',
            modele: 'Pour simplifier, imagine que... C\'est un peu comme quand... L\'idée principale, c\'est que... Si tu veux aller plus loin, je peux te recommander [ressource]. L\'essentiel à retenir, c\'est que...',
            structures: ['Analogie (c\'est comme)', 'Simplification (pour simplifier)', 'Hiérarchisation (l\'essentiel, c\'est que)'],
          },
        ],
      },
    ],
  },
};
